export const assertEnv = (env: string) => {
  const v = process.env[env]
  if (v === undefined) {
    throw new Error(`env var ${env} missing`)
  }
  return v
}